import { NavLink } from "react-router-dom"
import Faq from "./faq"
import { useLanguage } from "../i18n/LanguageContext"
import { legalContent } from "../i18n/content/legal"

export default function Use() {
    const { lang, withPath } = useLanguage();
    const c = legalContent[lang];
    const page = c.terms;
    const contactNumber = page.sections.length + 1;

    return (
        <>
            {/* Header Section */}
            <section className="text-white py-8 border-b-4 border-secondary" style={{background: 'linear-gradient(135deg, #1D4ED8, #2563EB)'}}>
                <div className="h-[25vh]"></div>
                <div className="main-content">
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-4xl font-bold">{page.pageTitle}</h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mb-4">
                        <span className="text-sm"><NavLink to={withPath('/')} className="transition-all duration-500 hover:text-white/70">{c.breadcrumbHome}</NavLink> / <span className="text-white/70">{page.pageTitle}</span></span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="text-ink py-12 min-h-[80vh]" style={{backgroundColor: 'var(--bg-color)'}}>
                <div className="main-content">
                    <div className="space-y-8">
                        {page.sections.map((section) => (
                            <div key={section.title}>
                                <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
                                <p className="text-base leading-relaxed">
                                {section.body}
                                </p>
                                {section.body2 && (
                                    <p className="text-base leading-relaxed pt-2">
                                    {section.body2}
                                    </p>
                                )}
                            </div>
                        ))}

                        {/* Contact section */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4">{contactNumber}. {c.contactSectionTitle}</h2>
                            <p className="text-base leading-relaxed mb-4">
                                {c.contactIntro}
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-base">
                                <li>{c.emailLabel}</li>
                                <li>
                                    {c.whatsappLabel}{" "}
                                    <a
                                        href="https://wa.me/32460201577"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary underline hover:text-primary-dark"
                                    >
                                        {c.whatsappCta}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="mt-12 pt-8 border-t border-line">
                            <p className="text-base leading-relaxed">
                                {c.conclusion}
                            </p>
                        </div>
                    </div>
                </div>
                <Faq/>
            </section>

        </>
    )
}
